#import "../fragments/landing-page-full-fragment.graphql"

query GetLandingPage($pageId: ID!) {
    page(id: $pageId) {
        ...LandingPageFullFragment
    }
}
